<style lang="scss" src='./Header.scss' scoped></style>
<template src="./Header.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
  } from "vuex";

  import ZipCodeModal from '@/components/zipCodeModal/ZipCodeModal'
  import MenuLateral from '@/components/menuLateral/MenuLateral'
  import CouponsModal from '@/components/couponsModal/CouponsModal'

  export default {
    name: 'StoreHeader',
    components: {
      ZipCodeModal,
      MenuLateral,
      CouponsModal,
    },
    data() {
      return {
        keys: null,
        search_category:null,
      };
    },
    computed: {
       ...mapState('CartStore', ['cartProducts']),
       ...mapState('CartStore', ['cartProducts']),
       ...mapState(['user']),
       ...mapState("Main", ['categorysList']),
       ...mapGetters("Main", ['getCurrentStore', 'getShowAddressModal']),
    },

    watch: {
      '$route': {
        handler: function (route) {
          if( route.path != '/search'){
            this.keys = null;
            this.search_category = null;
            this.setSearchParams({keys: null, categoryId: null});
          }else{
            this.keys = route.query.keys;
            this.search_category = route.query.category ? route.query.category : null;
            this.setSearchParams({keys: this.keys, categoryId: this.search_category});
          }
          if( route.path != '/payment/summary'){
            this.setIsCheckout(false);
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      ...mapMutations('CartStore', ["setVisibility"]),
      ...mapMutations( ["setMenuVisibility"]),
      ...mapMutations(["setZipCodeModal", "setCouponsModal", "setIsCheckout"]),
      ...mapMutations('Main', ['setSearchParams']),
      ...mapActions('Main', ['fnApiGetProducts']),
      ...mapActions( ['reset']),
      fnSearch() {
        if(this.keys == null || this.keys.length == 0){
          return false;
        }
        this.$router.push({
            path: '/search',
            query: {
              keys: this.keys,
              category: this.search_category
            }
          }).catch(()=>{});
      },

      fnCategoryChange() {
        if(!this.search_category){
          this.$router.push({
            path: '/'
          });
        }else{
          if(this.keys == null || this.keys.length == 0){
            this.$router.push({
              path: '/search',
              query: {
                category: this.search_category
              }
            }).catch(()=>{});
          }else{
            this.fnSearch();
          }
        }
      },
      getSearchPlaceholder() {
        if(this.search_category && this.categorysList){
          let cat = this.categorysList.find(x => x.category_id == this.search_category);
          if(cat){
            return this.$t('general.searchAt') + ' ' + cat.label;
          }
          return this.$t('general.whatAreYouLokingFor');
        }else if(this.search_category == null){
          return this.$t('general.searchAt') + ' ' + (this.$t('general.allCategories')).toLowerCase();
        }else{
          return this.$t('general.whatAreYouLokingFor');
        }
      },
    },

    beforeCreate() {},

    created() {},

    mounted() {
      this.search_category = null;
    },

    beforeDestroy() {

    },
  };

</script>
